import richEditor from './richEditor.vue';
export default richEditor;



// WEBPACK FOOTER //
// ./src/components/richEditor/index.js